import { StyledUSerPanelRoleElements } from '../../atoms/UserPanelAddRole/StyledUSerPanelRoleElements';
import { StyledUserPanelPermissionsComponent } from './UserPanelPermissions.styles';
import PermissionElement from './PermissionsElement/PermissionsElement';

const UserPanelPermissionsComponent = ({ permissions, trigger }) => {
    return (
        <StyledUserPanelPermissionsComponent>
            <StyledUSerPanelRoleElements>
                {permissions.map((p) => (
                    <PermissionElement key={p.permission} permission={p} trigger={trigger} />
                ))}
            </StyledUSerPanelRoleElements>
        </StyledUserPanelPermissionsComponent>
    );
};

export default UserPanelPermissionsComponent;
